export default __webpack_public_path__ + "static/media/logo.cac928fa.png";